import { Pipe, PipeTransform, NgModule } from '@angular/core';
import { isString, isUndefined } from '../utils';

@Pipe({
  name: 'replace',
})
export class ReplacePipe implements PipeTransform {
  transform(input: any, pattern: any, replacement: any): any {
    if (!isString(input) || isUndefined(pattern) || isUndefined(replacement)) {
      return input;
    }

    let regex = new RegExp(pattern, 'g');
    return input.replace(regex, replacement);
  }
}

@NgModule({
  declarations: [ReplacePipe],
  exports: [ReplacePipe],
})
export class ReplacePipeModule {}